module.exports = "<div ng-repeat=\"msg in $ctrl.messages\" class=alert-overlay-wrapper> <div uib-alert class=alert-overlay dismiss-on-timeout=\"{{ msg.timeout || '1000000' }}\" ng-class=\"'alert-' + (msg.type || 'warning')\" close=$ctrl.removeMessage($index) template-url=app/messages/alert_partial.html> {{ msg.text }}</div> </div>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/messages/container_partial.html
// module id = 419
// module chunks = 0